import { IconProps } from "./IconProps";

const QuickTransactionIcon: React.FC<IconProps> = ({
  width = 30,
  height = 30,
  color = "#0F5051",
  color2 = "#FFFFFF",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 23 24" fill="none">
      <rect y="0.173828" width="23" height="23" rx="5.75" fill={color} />
      <path
        d="M16.8751 11.7144V9.71441C16.8751 9.29774 16.7293 8.94357 16.4376 8.6519C16.1459 8.36023 15.7917 8.21439 15.3751 8.21439H10.7875L12.5875 10.0144L11.875 10.7144L8.875 7.71439L11.875 4.71436L12.5875 5.41436L10.7875 7.21438H15.3751C16.0667 7.21438 16.6563 7.45814 17.1438 7.94564C17.6313 8.43315 17.8751 9.02274 17.8751 9.71441V11.7144H16.8751Z"
        fill={color2}
      />
      <path
        d="M11.1251 18.6339L10.4251 17.9214L12.2126 16.1338H7.37502C6.75002 16.1338 6.21876 15.9151 5.78126 15.4776C5.34375 15.0401 5.125 14.5088 5.125 13.8838C5.125 13.2588 5.34375 12.7276 5.78126 12.29C6.21876 11.8525 6.75002 11.6338 7.37502 11.6338H7.62503V12.6338H7.37502C7.02502 12.6338 6.72918 12.7546 6.48751 12.9963C6.24585 13.238 6.12501 13.5338 6.12501 13.8838C6.12501 14.2338 6.24585 14.5297 6.48751 14.7713C6.72918 15.013 7.02502 15.1338 7.37502 15.1338H12.2126L10.4251 13.3338L11.1251 12.6338L14.1251 15.6338L11.1251 18.6339Z"
        fill={color2}
      />
    </svg>
  );
};
export default QuickTransactionIcon;
